<template>
	<div>
		<Card>
		<Row :gutter="16">
			<Col span="24">
				<Tabs value="name1">
					<TabPane label="APP广告" name="name1">
						<AppAd ref="appAd" />
					</TabPane>
					<TabPane label="PC广告" name="name2">
						<PcAd ref="pcAd" />
					</TabPane>
				</Tabs>	
			</Col>
		</Row>
		</Card>
	</div>
</template>

<script>
import AppAd from './app-ad.vue';
import PcAd from './pc-ad.vue';

export default {
    name: 'AdList',
    components: {
        AppAd,
	  PcAd
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
        
    }
};
</script>

<style lang="less" scoped>

</style>
